import * as _ from 'underscore';
//import { Template as Template_Apps } from 'mappApps/compile/templates'
//import { Template as Template_Management } from 'mappManagement/compile'
//import { Template as Template_Studio } from 'mappStudio/compile'

import { Template } from '../compile';

export class StringTemplate {
	private name: string;
	private domTemplate: KnockoutTemplateSourcesDomElement;
	private templates: any;

	constructor(name: string, templates: any, templateDocument: Document) {
		this.name = name;
		templateDocument = templateDocument || document;
		var elem = templateDocument.getElementById(name);
		this.templates = templates;

		if (elem) this.domTemplate = new ko.templateSources.domElement(elem);
	}

	public data(key: string, value: any) {
		return this.domTemplate.data.apply(this.domTemplate, arguments);
	}

	public text(value: any) {
		if (this.templates[this.name]) {
			if (arguments.length == 0) {
				return this.templates[this.name];
			} else {
				this.templates[this.name] = value;
			}
		} else {
			return this.domTemplate.text.apply(this.domTemplate, arguments);
		}
	}
}
